import { Component, OnInit , ElementRef} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import { SharedService } from "src/app/services/shared.service";

@Component({
  selector: "app-registration",
  templateUrl: "./outboundregistration.component.html",
  styleUrls: ["./outboundregistration.component.css"],
})
export class OutboundregistrationComponent implements OnInit {
  apiUrl: string;
  registerForm: FormGroup;
  preboardingForm: FormGroup;
  submitted = false;
  loginLogo: boolean;
  personalInfoTab: boolean = true;
  paymentTab: boolean;
  confirmationTab: boolean;
  personalInfo: any;
  appointmentForm: FormGroup;
  paymentGatewayForm: FormGroup;
  otpForm: FormGroup;
  requestObj: any;
  bookAppointmentTab: boolean;
  travelInfo: any;
  centerId = 0;
  centerAmount = 0;
  arrivalDate: any;
  booking_info: any;
  fullName: string;
  passportNumber: any;
  travelDate: any;
  appointment: string;
  airlines: any;
  travelTypes: any;
  lgas: any;
  centerName: any;
  collectionCenters: any;
  date: Date;
  timeout: any;
  passportDetails: any;
  confirmed: boolean = false;
  travelDateStatus: boolean;

  passengerInformation: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private utility: UtilityService,
    private spinnerService: Ng4LoadingSpinnerService,
    private el: ElementRef,
    public shared: SharedService

  ) {
    this.travelDateStatus = false;
  }

  ngOnInit() {
    this.loginLogo = true;
    // this.sess.islogin();
    this.spinnerService.show();
    this.date = new Date();
    this.initialiseRegistrationForm();
    this.spinnerService.hide();
    $(".mobile-menu").css("display", "none");
    this.getTravelTypes();
    this.getAirlines();
    this.getLgas();
    this.getCollectionCenters();

    // this.initPaymentGatewayForm();
    this.initialiseOtpForm();
    this.shared.getCountries();
  }

  initialiseRegistrationForm() {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        confirmEmailAddress: [
          "",
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        firstName: [
          "",
          [
            Validators.required,
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.maxLength(45),
          ],
        ],
        middleName: [
          "",
          [
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        lastName: [
          "",
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        // countryDeparting: ['', [Validators.required]],

        nationality: [
          "",
          [
            Validators.required,
            Validators.pattern("[a-zA-Z][a-zA-Z ]+"),
          ],
        ],
        phone: [
          "",
          [
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(9),
          ],
        ],
        passportNumber: [
          "",
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.maxLength(15),
          ],
        ],
        gender: ["", Validators.required],
        airline: ["", Validators.required],
        travelLocation: [
          "",
          [
            Validators.required,
            Validators.pattern("[a-zA-Z][a-zA-Z ]+"),
          ],
        ],
        countryOfResidence: [
          "",
          [
            Validators.required,
            Validators.pattern("[a-zA-Z][a-zA-Z ]+"),
          ],
        ],
        travelDate: ["", Validators.required],
        returnDate: [""],
        // returnDate: ['', Validators.required],
        dateOfBirth: ["", Validators.required],
        currentAddress: [
          "",
          [
            Validators.required,
            Validators.maxLength(60),
            Validators.pattern(
              "^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 -,./_)(&+]*$"
            ),
          ],
        ],
        occupation: [
          "",
          [
            Validators.required,
            Validators.maxLength(45),
            Validators.pattern("^[A-Za-z ]*$"),
            // Validators.pattern("[a-zA-Z][a-zA-Z -]+"),
          ],
        ],
      },
      {
        validator: this.utility.MustMatch(
          "emailAddress",
          "confirmEmailAddress"
        ),
      }
    );
  }

  initBookingForm() {
    this.appointmentForm = this.formBuilder.group({
      testState: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z ]+$"),
          //   Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      travelDate: [""],
      bookingDate: ["", [Validators.required]],
      bookingTime: ["", [Validators.required]],
      testLga: ["", [Validators.required]],
    });
  }

  updateBookingForm(form) {
    this.appointmentForm = this.formBuilder.group({
      testState: [
        form.prefer_state,
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z ]+$"),
          //   Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      travelDate: [this.travelDate],
      bookingDate: [form.booking_date, [Validators.required]],
      bookingTime: [form.booking_time, [Validators.required]],
      testLga: [form.lga_code_id, [Validators.required]],
    });
  }

  initPaymentGatewayForm() {
    this.paymentGatewayForm = this.formBuilder.group({
      amount: [
        this.centerAmount,
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(1),
        ],
      ],
      cardNumber: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(15),
        ],
      ],
      expiryDateMonth: [
        "Month",
        [
          Validators.required,
          //   Validators.pattern("^[0-9]*$"),
          //   Validators.minLength(2),
        ],
      ],
      expiryDateYear: [
        "Year",
        [
          Validators.required,
          //   Validators.pattern("^[0-9]*$"),
          //   Validators.minLength(4),
        ],
      ],
      ccvCode: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(3),
        ],
      ],
      cardHolderName: [
        "",
        [Validators.required, Validators.pattern("^[a-z A-Z]+$")],
      ],
      saveCardDetails: [false],
    });
  }

  updatePaymentGatewayForm(data: any) {
    this.paymentGatewayForm = this.formBuilder.group({
      amount: [data.amount, [Validators.required]],
      cardNumber: [data.cardNumber, [Validators.required]],
      expiryDateMonth: [data.expiryDateMonth, [Validators.required]],
      expiryDateYear: [data.expiryDateYear, [Validators.required]],
      ccvCode: [data.ccvCode, [Validators.required]],
      cardHolderName: [data.cardHolderName, [Validators.required]],
      saveCardDetails: [data.saveCardDetails],
    });
  }

  initialiseOtpForm() {
    this.otpForm = this.formBuilder.group({
      enterOtp: ["", [Validators.required, Validators.pattern(/^[0-9]*$/)]],
    });
  }

  onSubmitPersonalInfo(formData) {
    this.submitted = true;

    if (this.registerForm.invalid) {
      for (const key of Object.keys(this.registerForm.controls)) {
        if (this.registerForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          invalidControl.focus();
          break;
        }
      }
      return;
    }

    this.personalInfo = {
      passport_no: formData.passportNumber,
      phone: formData.phone,
      email: formData.emailAddress,
      address_residential: formData.currentAddress,
      confirm_email: formData.confirmEmailAddress,
      first_name: formData.firstName,
      middle_name: formData.middleName,
      last_name: formData.lastName,
      nationality: formData.nationality,
      dob: formData.dateOfBirth,
      country_residence: formData.countryOfResidence,
      // airline: formData.airline,
      occupation: formData.occupation,
      gender: formData.gender,
    };
    this.travelInfo = {
      departure_date: formData.travelDate,
      departure_country: formData.travelLocation,
      return_date: formData.returnDate,
      airline: formData.airline,
      type: "1",
    };
    // this.fullName = `${formData.firstName} ${formData.middleName} ${formData.lastName}`;

    this.fullName =
      formData.firstName + " " + formData.middleName + " " + formData.lastName;

    this.travelDate = formData.travelDate;
    this.passportNumber = formData.passportNumber;

    // console.log('person ', this.personalInfo);
    // console.log('travel ', this.travelInfo);
    this.submitted = false;
    this.showBookAppointment();
  }

  onSubmitAppointment(formData) {
    this.submitted = true;

    if (this.appointmentForm.invalid) {
      for (const key of Object.keys(this.appointmentForm.controls)) {
        if (this.appointmentForm.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          invalidControl.focus();
          break;
        }
      }
      return;
    }
    this.submitted = false;

    this.booking_info = {
      booking_date: formData.bookingDate,
      booking_time: formData.bookingTime,
      center_id: this.centerId,
      lga_code_id: formData.testLga,
      prefer_state: formData.testState,
    };
    this.appointment = `${formData.bookingDate} ${formData.bookingTime}`;
    this.showConfirmation();
  }

  changeTravelDate(travelDate) {
    this.travelDate = travelDate;
    this.travelDateStatus = true;
    // console.log(this.travelDateStatus);
  }

  submitOutbound() {
    if ((this.confirmed = false)) {
      Swal.fire({
        icon: "info",
        title: "Confirm Booking Date",
        text: "Please confirm booking date and time slot.",
        showConfirmButton: true,
        timer: 5000,
      });

      return;
    } else {
      const request = {
        passenger_info: this.personalInfo,
        travel_info: this.travelInfo,
        booking_info: this.booking_info,
      };
      this.spinnerService.show();

      this.apiUrl = environment.AUTHAPIURL + "passenger-outbound/register";

      this.http.post<any>(this.apiUrl, request).subscribe((data) => {
        console.log("registerApiResponse: ", data);
        this.passengerInformation = data.response;
        this.spinnerService.hide();

        if (data.status == true && data.response) {
          this.confirmed = true;
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
          this.showPayment();
          this.utility.gotoTop();
        } else {
          this.confirmed = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
            // text:
            //   data.response != null ? data.response[0].message : data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
    }
  }

  showPersonalInfo() {
    this.confirmed = false;
    this.personalInfoTab = true;
    this.bookAppointmentTab = false;
    this.confirmationTab = false;
    this.paymentTab = false;
    this.booking_info = {
      booking_date: this.appointmentForm.get("bookingDate").value,
      booking_time: this.appointmentForm.get("bookingTime").value,
      center_id: this.centerId,
      lga_code_id: this.appointmentForm.get("testLga").value,
      prefer_state: this.appointmentForm.get("testState").value,
    };
    this.updateBookingForm(this.booking_info);
    // this.initialiseRegistrationForm();
  }
  showBookAppointment() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = true;
      this.confirmationTab = false;
      this.paymentTab = false;

      if (this.booking_info == null) {
        this.appointmentForm = this.formBuilder.group({
          testState: [
            "",
            [
              Validators.required,
              Validators.pattern("^[a-zA-Z ]+$"),
              //   Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            ],
          ],
          travelDate: [this.travelDate],
          bookingDate: ["", [Validators.required]],
          bookingTime: ["", [Validators.required]],
          testLga: ["", [Validators.required]],
        });
      } else {
        this.updateBookingForm(this.booking_info);
      }
    }
  }

  backBookAppointment() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = true;
      this.confirmationTab = false;
      this.paymentTab = false;

      this.appointmentForm = this.formBuilder.group({
        testState: [
          this.booking_info.prefer_state,
          [
            Validators.required,
            Validators.pattern("^[a-zA-Z ]+$"),
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
          ],
        ],
        travelDate: [this.travelDate],
        bookingDate: [this.booking_info.booking_date, [Validators.required]],
        bookingTime: [this.booking_info.booking_time, [Validators.required]],
        testLga: [this.booking_info.lga_code_id, [Validators.required]],
      });
    }
  }

  showConfirmation() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    if (this.appointmentForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = true;
      this.paymentTab = false;
    }
  }

  showPayment() {
    if (this.registerForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }
    if (this.appointmentForm.invalid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: "Please complete the required fields.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    } else {
      this.initPaymentGatewayForm();
      this.personalInfoTab = false;
      this.bookAppointmentTab = false;
      this.confirmationTab = false;
      this.paymentTab = true;
    }
  }

  onShowOTP(formData) {
    this.submitted = true;

    console.log(formData);

    if (this.paymentGatewayForm.invalid) {
      return;
    }
    this.submitted = false;

    if (!this.passengerInformation) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please complete the book appointment form to proceed.",
        showConfirmButton: true,
        timer: 5000,
      });
      return;
    }

    this.spinnerService.show();
    // this.initialiseOtpForm();
    setTimeout(() => {
      this.spinnerService.hide();
      $("#showOtpForm").trigger("click");
      // showOtpForm
    }, 1000);
  }

  onMakePayment(formData = null) {
    // this.submitted = true;

    console.log(formData);

    // if (this.paymentGatewayForm.invalid) {
    //   return;
    // }

    // if (!this.passengerInformation) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Please complete the book appointment form to proceed.",
    //     showConfirmButton: true,
    //     timer: 5000,
    //   });
    //   return;
    // }

    // var requestObj = {
    //   ctms_passenger_id: this.passengerInformation.ctms_passenger_id,
    //   payment_status: true,
    // };

    this.requestObj["ctms_passenger_id"] =
      this.passengerInformation.ctms_passenger_id;
    this.requestObj["payment_status"] = true;

    console.log(this.requestObj);

    this.spinnerService.show();

    this.apiUrl = environment.AUTHAPIURL + "passenger-payment/update";

    this.http.post<any>(this.apiUrl, this.requestObj).subscribe((data) => {
      console.log("paymentApiResponse: ", data);
      this.spinnerService.hide();

      if (data.status == true) {
        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: data.message,
        //   showConfirmButton: true,
        //   timer: 10000,
        // });
        // this.showPayment();
        // this.utility.gotoTop();
        //redirect to home
        // this.router.navigate(["/"]);
		this.router.navigate(["/paymentstatuspage"]);        
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    });
  }

  onOtpSubmit(otpFormData) {
    this.submitted = true;
    this.requestObj = {};
    this.requestObj.otp = otpFormData.enterOtp;
    console.log("otpFormData: ", otpFormData);
    console.log("loginRequest: ", this.requestObj);

    if (this.otpForm.invalid) {
      return;
    }

    this.submitted = false;

    this.onMakePayment();
  }

  getTravelTypes() {
    this.apiUrl = environment.AUTHAPIURL + "travel-types";

    this.http.get<any>(this.apiUrl).subscribe((data) => {
      console.log("travelTypes: ", data);
      this.travelTypes = data.response;
    });
  }

  getAirlines() {
    this.apiUrl = environment.AUTHAPIURL + "airlines";

    this.http.get<any>(this.apiUrl).subscribe((data) => {
      console.log("airline: ", data);
      this.airlines = data.response;
    });
  }

  getLgas() {
    this.apiUrl = environment.AUTHAPIURL + "lga-list";
    const obj = {};
    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("lga: ", data);
      this.lgas = data.response;
    });
  }

  getCollectionCenters() {
    this.apiUrl = environment.AUTHAPIURL + "collection-center-list?page=1";

    const obj = {
      per_page: 100,
    };
    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("collectionCenters: ", data);
      this.collectionCenters = data.response;
    });
  }

  updateRegistrationForm(passenger, travel) {
    this.registerForm = this.formBuilder.group(
      {
        emailAddress: [
          passenger.email,
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        confirmEmailAddress: [
          passenger.confirm_email,
          [Validators.required, Validators.maxLength(45), Validators.email],
        ],
        firstName: [
          passenger.first_name,
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        middleName: [
          passenger.middle_name,
          [
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        lastName: [
          passenger.last_name,
          [
            Validators.required,
            // Validators.pattern("^[A-Za-z 0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
            Validators.pattern("^[A-Za-z ]*$"),
            Validators.maxLength(45),
          ],
        ],
        countryOfResidence: [passenger.country_residence, Validators.required],

        nationality: [passenger.nationality, [Validators.required]],
        phone: [
          passenger.phone,
          [
            Validators.required,
            Validators.minLength(9),
            Validators.pattern("^[0-9]*$"),
          ],
        ],
        passportNumber: [
          passenger.passport_no,
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(15),
          ],
        ],
        gender: [passenger.gender, Validators.required],
        airline: [
          travel.airline ? travel.airline.toString() : "",
          Validators.required,
        ],
        travelLocation: [travel.departure_country, Validators.required],
        travelDate: [travel.departure_date, Validators.required],
        returnDate: [travel.return_date],
        // returnDate: [travel.return_date, Validators.required],
        // returnDate: ['', Validators.required],
        dateOfBirth: [passenger.dob, Validators.required],
        currentAddress: [
          passenger.address_residential,
          [Validators.required, Validators.maxLength(60)],
        ],
        occupation: [
          passenger.occupation,
          [Validators.required, Validators.maxLength(45), Validators.pattern("^[A-Za-z ]*$"),],
        ],
      },
      {
        validator: this.utility.MustMatch(
          "emailAddress",
          "confirmEmailAddress"
        ),
      }
    );
  }

  confirmTimeSlot() {
    // this.confirmed = true;
    const obj = {
      travel_date: this.travelDate,
      booking_time: this.appointmentForm.get("bookingTime").value,
      booking_date: this.appointmentForm.get("bookingDate").value,
      center_id: this.centerId,
    };
    this.apiUrl = environment.AUTHAPIURL + "verify-booking-slot";

    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("verify booking: ", data);
      this.spinnerService.hide();

      if (data.status == true) {

        this.confirmed = true;

        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.response != null ? data.response[0].message : data.message,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    });
  }

  getPassportDetails(event: any) {
    this.spinnerService.show();
    let obj = {};
    let passportNumber = event.target.value;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (event.keyCode != 13) {
        this.apiUrl =
          environment.AUTHAPIURL +
          "passenger-existing-record/" +
          passportNumber;

        this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
          console.log("passportDetails: ", data);
          this.passportDetails = data.response;
          if (data.status == true) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "A record found. Please confirm the information and update accordingly.",
              showConfirmButton: true,
              timer: 4000,
            });

            this.updateRegistrationForm(
              this.passportDetails.passenger_info,
              this.passportDetails.travel_info
            );

            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
          }
        });
      }
    }, 3000);
  }
}
